var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityState, EntityStore, ID, QueryEntity, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
var ActionStore = /** @class */ (function (_super) {
    __extends(ActionStore, _super);
    function ActionStore() {
        return _super.call(this, { size: 25, pageIndex: 0, total: 0, pageIds: [] }) || this;
    }
    ActionStore.prototype.upsertPage = function (events, size, pageIndex, total) {
        var _this = this;
        var eventIds = events
            .map(function (event) {
            _this.upsert(event.id, event);
            return event.id;
        });
        this.updateRoot({
            size: size,
            pageIndex: pageIndex,
            total: total,
            pageIds: eventIds
        });
    };
    ActionStore = __decorate([
        StoreConfig({ name: 'action' }),
        __metadata("design:paramtypes", [])
    ], ActionStore);
    return ActionStore;
}(EntityStore));
export { ActionStore };
var ActionQuery = /** @class */ (function (_super) {
    __extends(ActionQuery, _super);
    function ActionQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        return _this;
    }
    ActionQuery.prototype.getPageIndex = function () {
        return this.getSnapshot().pageIndex;
    };
    ActionQuery.prototype.getSize = function () {
        return this.getSnapshot().size;
    };
    ActionQuery.prototype.getTotal = function () {
        return this.getSnapshot().total;
    };
    ActionQuery.prototype.selectPageIndex = function () {
        return this.select(function (state) { return state.pageIndex; });
    };
    ActionQuery.prototype.selectSize = function () {
        return this.select(function (state) { return state.size; });
    };
    ActionQuery.prototype.selectTotal = function () {
        return this.select(function (state) { return state.total; });
    };
    ActionQuery.prototype.selectPage = function () {
        var _this = this;
        return this.select(function (state) { return state.pageIds.map(function (id) { return _this.getEntity(id); }); });
    };
    ActionQuery.ngInjectableDef = i0.defineInjectable({ factory: function ActionQuery_Factory() { return new ActionQuery(i0.inject(ActionStore)); }, token: ActionQuery, providedIn: "root" });
    return ActionQuery;
}(QueryEntity));
export { ActionQuery };
